var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActionPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.083,
    height: 17.083,
    viewBox: "0 0 17.083 17.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-action-plans",
    d: "M16.415,0H.667A.667.667,0,0,0,0,.667V16.415a.667.667,0,0,0,.667.667H16.415a.667.667,0,0,0,.667-.667V.667A.667.667,0,0,0,16.415,0Zm-.667,15.748H1.335V1.335H15.748ZM2.731,4.577a.667.667,0,0,1,.944-.944l.432.432L5.534,2.639a.667.667,0,0,1,.944.944l-1.9,1.9a.667.667,0,0,1-.944,0ZM7.874,4.06a.667.667,0,0,1,.667-.667H13.88a.667.667,0,0,1,0,1.335H8.541a.667.667,0,0,1-.667-.667ZM2.731,13.54a.667.667,0,0,1,.944-.944l.432.432L5.534,11.6a.667.667,0,0,1,.944.944l-1.9,1.9a.667.667,0,0,1-.944,0Zm5.143-.517a.667.667,0,0,1,.667-.667H13.88a.667.667,0,1,1,0,1.335H8.541a.667.667,0,0,1-.667-.667ZM2.731,9.059a.667.667,0,0,1,.944-.944l.432.432L5.534,7.12a.667.667,0,1,1,.944.944l-1.9,1.9a.667.667,0,0,1-.944,0Zm5.143-.517a.667.667,0,0,1,.667-.667H13.88a.667.667,0,0,1,0,1.335H8.541a.667.667,0,0,1-.667-.667Zm0,0",
    fill: "#45338c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionPlans);
export default __webpack_public_path__ + "static/media/icon-action-plans.f998cba4e63e924327e103a11ce509e3.svg";
export { ForwardRef as ReactComponent };